import { useEffect, useState } from 'react';

import Popup from '../../../components/popup';

import GrantsApi from '../../../lib/grants/grants-api';

import { ProceedButton, CancelButton} from '../../../components/buttons';

export default ({ setPopup, amends, amended, confirm }) => {
    return (
        <Popup type="new-version">
            <div class="popup__inner">
                <h1>{ amended !== 0 ? amended == amends ? 
                    'Are you sure you wish to proceed with all changes made?' :
                    'You have changes outstanding - are you sure you wish to proceed?' :
                    'You have no changes'
                }</h1>
                
                <p>{  amended !== 0 ? amended == amends ? 
                    `You have made ${amended}/${amends} changes to your application. Once submitted, your updated application will be reviewed by the assessment team.` : 
                    `You have made ${amended}/${amends} changes to your application. Once submitted, you will only be able to amend any unanswered questions remaining.` :
                    `You have made ${amended}/${amends} changes to your application. To submit you need to atleast have amended 1 question`
                    }
                </p>

                <div class="popup__buttons">
                    <ProceedButton responsive={false} onClick={confirm} disabled={amended == 0} color="green">Confirm</ProceedButton>
                    <CancelButton  responsive={false} onClick={() => setPopup(false)}>Cancel</CancelButton>
                </div>
            </div>
        </Popup>
    )
}
